import kendoDatatableParams from '@helpers/kendoDatatableParams';

// Query params used by the mass-action modals (Update, Generate Reports, Push To TCE/IROL/LivSafe,
// Export CSV) when the user picks "Select all N inspections entirely". The backend re-resolves the
// selected ids from these params, so they MUST narrow the data the same way the grid's own datatable
// request does — panel filters AND the search term (IP-14655: omitting search made "select all 21"
// update every non-cancelled inspection in the tenant).
export default function massActionQueryParams({ filters, search }) {
  const { asset, ...valuesFiltered } = filters.values;

  return kendoDatatableParams({
    filters: { ...filters, values: valuesFiltered },
    search,
    optionalParams: asset && Array.isArray(asset) && { asset: asset.join(',') }
  });
}
